export const infobox_animation = (isMobileOptimized) => ({
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: isMobileOptimized ? 0.2 : 0.05 },
});
